<template>
  <b-card
    :header="module.module.name"
    header-class="header"
    class="card shadow mb-4 bg-white rounded"
    lg="3"
    md="5"
    xm="12"
    xs="12"
    header-bg-variant="info"
    border-variant="info"
    border-header-variant="info"
  >
    <ProgressBar :progress="module.completion" :exams="module.exams" :plus="module.module.is_plus" :order="module.module.order" class="progress-container"></ProgressBar>

    <b-card-footer class="bottom-0" align-v="center">
      <b-button-group vertical v-if="module.module.is_plus==false || module.module.is_plus==true && isPlusUser==true && nbModulesCompleted>=5">
        <b-button
          v-if="module.completion < 100 && isCourseConsulted(module.exams) == true"
          pill
          class="button"
          variant="secondary"
          :to="{name: 'HomeExercise', params: { id: module.module.id }}"
          >
            <span v-if="isStartedExercise"><b-icon-pause-circle animation="fade" variant="dark" class="pause-notif rounded-circle bg-light"></b-icon-pause-circle>Continuer l'exercice</span>
            <span v-else>Démarrer l'exercice</span>
          </b-button>
        <b-button
          pill
          class="button"
          variant="primary"
          :to="{name: 'Course', params: { moduleId: module.module.id }}"
          ><b-icon-exclamation-circle-fill v-if="isCourseConsulted(module.exams) == false" variant="danger" class="course-notif rounded-circle bg-light"></b-icon-exclamation-circle-fill> Consulter le support de formation</b-button
        >
      </b-button-group>
      <b-button-group v-else vertical style="height: 0px; margin: 0px; padding: 0px;">
        <b-button
          pill
          class="button"
          variant="primary"
          disabled
          style="height: 1px; margin: 0px; padding: 0px; z-index: -10"
          >Consulter le support de formation</b-button
        >
      </b-button-group>
    </b-card-footer>
  </b-card>
</template>

<script>
import Store from '@/store/index.js'
import ProgressBar from "@/components/ProgressBar.vue";
export default {
  components: {
    ProgressBar,
  },
  props: {
    module: Object,
  },
  computed: {
    isStartedExercise() {
      return (this.module.exams[0] && this.module.exams[0].is_ended == false) ? true : false;
    },
    isPlusUser() {return Store.getters.getIsPlus()},
    nbModulesCompleted() {return parseInt(Store.getters.getNbModulesCompleted())},
  },
  methods: {
    percentFormatter: ({ currentValue }) => {
      return `
        ${new Intl.NumberFormat("fr-FR").format(currentValue)}
        <span>%</span>
      `;
    },
    isCourseConsulted(exams) {
      let courseConsulted = true;
      if (exams[0] && exams[0].is_ended == true) {
        exams[0].exam_data.forEach((exam_data) => {
          if (exam_data.course_consulted == false) {
            courseConsulted = false;
          }
        });
      }
      return courseConsulted;
    },
  },
  data() {
    return {};
  },
};
</script>

<style scoped>
.card {
  margin: 30px 1px 0;
  border-radius: 15px;
  overflow: hidden;
  max-width: 20rem;
}
.card-header {
  font-weight: 600;
}
.card-body {
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  padding-bottom: 0rem;
  padding-left: 0rem;
  padding-right: 0rem;
}
.card-footer {
  background-color: transparent;
  border: none;
  margin: auto 20px;
}
.card-text {
  word-wrap: break-word;
}
.button {
  margin-bottom: 20px;
  width: 95%;
}
.row {
  margin-top: 20px;
  margin-bottom: 20px;
}
.progress-circle-bar {
  margin: 5% auto 8%;
}
.course-notif {
  position: absolute;
  left: 5px;
  top: -10px;
}
.pause-notif {
  position: absolute;
  left: 5px;
  top: 8px;
}
.progress-container {
  min-height: 210px;
}
</style>